import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import {eliminarCartera, mostrarCarteraById} from '../../redux/reducers/carterasReducers';

import {formatDate, formatPeso, hasPermissionTo, PERSMISOS, translateText,} from '../../helpers';
import {Button, Grid, Menu, MenuItem, TableBody, TableCell, TableRow, Theme, useMediaQuery} from '@mui/material';
import {AttachMoney} from '@mui/icons-material';

import {AppBar, ListViewMode, LoadingProgress, TableSort} from "../../components";
import Strings from "../../assets/strings";
import CounterItem from "../../components/homeWidget/CounterItem";
import ItemPrestamo from "../../components/CustomListItem/itemPrestamo";
import ConfirmDialog from "../../components/ConfirmDialog";
import Crear from "./crear";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import estadoPrestamo from "../../styles/estadoPrestamo";
import {ESTADO_PRESTAMO, getValueString, SITUACION_PRESTAMO} from "../../helpers/CONSTANTES";

const useStyles = makeStyles((theme:Theme) => ({
  tRow:{
    cursor: "pointer",
    "& .estado":{
      fontSize: ".9em"
    },
    ...estadoPrestamo(theme),
  },
}));

function DetallesCartera() {
  let {viewTableList} = useAppSelector(state => state.theme);
  const xsVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
  const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
  const classes = useStyles();
  const navigate = useNavigate();
  const {state:urlState, pathname} = useLocation();
  const dispatch = useAppDispatch();

  let { carId } = useParams();

  const [openMenu, setOpenMenu] = useState<null | HTMLElement>(null);
  const {byId:cartera, status} = useAppSelector(state => state.carteras);

  useEffect(() => {
    if (carId) {
      dispatch(mostrarCarteraById(parseInt(carId)));
    }
  }, [dispatch, carId]);


  const editar = ()=>{
    if(!hasPermissionTo(PERSMISOS.carterasActualizar)) return false;
    if(cartera) {
      navigate(pathname, {
        state: {
          id: cartera.id,
          descripcion: cartera.descripcion,
          capital: cartera.capital,
        }
      })
    }
  }
  return (
      <>
        <AppBar title={cartera?.descripcion??""}/>
        <div className={"contentInner"}>
          {status === "loading" && <LoadingProgress vh/>}

          <Grid container spacing={xsVewport?1:2} className={"d-print-none"}>
            {cartera?.resumen?.map(pre =>
                <Grid item xs={6} md={3} key={pre.key}>
                  <CounterItem title={translateText(pre.key!.toString())} color={"#ccc"} subTitle={formatPeso(pre.value)} Icon={AttachMoney}/>
                </Grid>
            )}
          </Grid>
          <ListViewMode pageRows={cartera?.prestamos?.length} pageTotalRows={cartera?.prestamos?.length}>
            <Button aria-haspopup="true" size={"small"} onClick={(e)=>setOpenMenu(e.currentTarget)}>
              Opciones
            </Button>
            <Menu id="long-menu" anchorEl={openMenu} keepMounted open={Boolean(openMenu)} onClose={()=>setOpenMenu(null)}>
              {hasPermissionTo(PERSMISOS.carterasActualizar) &&
                  <MenuItem onClick={() => navigate(pathname, {state:{confirmDialog: carId}})}>
                    {Strings.eliminar}
                  </MenuItem>
              }
              {hasPermissionTo(PERSMISOS.carterasEliminar) &&
                  <MenuItem onClick={editar}>{Strings.editar}</MenuItem>
              }
            </Menu>
          </ListViewMode>
          <div>
            {(!viewTableList && smVewport)?(
                cartera?.prestamos?.map(pre =>
                    <ItemPrestamo key={pre.id} onClick={()=>navigate(`/prestamo/${pre.id}`)} item={pre}/>
                )
            ):(
                <TableSort data={[
                  {pro:"cliente",text:Strings.prestatarios},

                  {pro:"preBalancePendiente",text:Strings.balance+" "+Strings.pendiente},
                  {pro:"montoCuota",text:Strings.monto+" "+Strings.cuota},
                  {pro:"mora",text:Strings.mora},
                  {pro:"preFechaProximoPago",text:Strings.proximo+" "+Strings.pago},
                  {pro:"capitalActual",text:Strings.capitalPendiente},
                  {pro:"preGastosLegales",text:Strings.gastosLegales},

                  {pro:"preTipoAmortizacion",text:Strings.amortizacion},
                  {pro:"prePlazo",text:"# "+Strings.cuota},
                  {pro:"preCapitalInicial",text:Strings.capitalInicial},
                  {pro:"totalPagos",text:Strings.totalPagado},

                  {pro:"preTasaInteres",text:Strings.interes},
                  {pro:"preCiclosPago",text:Strings.modalidad},

                  {pro:"preReferencia",text:Strings.codigoRef},
                  {pro:"preFecha",text:Strings.fecha+" "+Strings.prestamo},
                  {pro:"cajId",text:Strings.caja},

                ]} onSort={()=>{}}>
                  <TableBody>
                    {cartera?.prestamos?.map(pre =>
                        <TableRow key={pre.id} className={classes.tRow +" estado"+pre.estado+" situacion"+pre.situacion} onClick={()=>navigate(`/prestamo/${pre.id}`)}
                                  onContextMenu={(e)=>{e.preventDefault();window.open(`/prestamo/${pre.id}`,"_blank")}}>
                          <TableCell >
                            {pre.cliente}
                            <div className="estado">
                              {pre.estado === ESTADO_PRESTAMO.ACTIVO ? (
                                  <>{getValueString(SITUACION_PRESTAMO, pre.situacion)}</>
                              ):(
                                  <>{getValueString(ESTADO_PRESTAMO, pre.estado)}</>
                              )}

                              {(pre.estado === ESTADO_PRESTAMO.ACTIVO && pre.situacion === SITUACION_PRESTAMO.CUOTAS_VENCIDA) && ": "+pre.cuotasAtrasadas}
                            </div>
                          </TableCell>

                          <TableCell>{formatPeso(pre.balancePendiente)}</TableCell>
                          <TableCell>{formatPeso(pre.montoCuota)}</TableCell>
                          <TableCell>{formatPeso(pre.mora)}</TableCell>

                          <TableCell>{formatDate(pre.fechaProximoPago,"dd, DD/MM/YYYY")}</TableCell>
                          <TableCell>{formatPeso(pre.capitalActual)}</TableCell>

                          <TableCell>{formatPeso(pre.gastosLegales)}</TableCell>


                          <TableCell>{translateText(pre.tipoAmortizacionString)}</TableCell>
                          <TableCell>{pre.plazo}</TableCell>
                          <TableCell>{formatPeso(pre.capitalInicial)}</TableCell>
                          <TableCell>{formatPeso(pre.totalPagos)}</TableCell>

                          <TableCell>{pre.tasaInteres}%</TableCell>
                          <TableCell>{translateText(pre.ciclosPagoString)}</TableCell>
                          <TableCell>{pre.referencia}</TableCell>
                          <TableCell>{formatDate(pre.fecha)}</TableCell>
                          <TableCell>{pre.caja}</TableCell>

                        </TableRow>
                    )}
                  </TableBody>
                </TableSort>
            ) }
          </div>

        </div>
        <Crear/>
        <ConfirmDialog onConfirm={()=>dispatch(eliminarCartera(urlState?.confirmDialog))} />
      </>
  );


}

export default DetallesCartera;



